import { Toaster } from 'react-hot-toast';

export function ToasterStyling() {
  return (
    <Toaster
      position='top-center'
      reverseOrder={false}
      gutter={8}
      containerClassName=''
      containerStyle={{}}
      toastOptions={{
        // Define default options
        className: 'text-sm ',
        duration: 5000,
        removeDelay: 1000,
        style: {
          maxWidth: 400,
        },

        // Default options for specific types
        success: {
          duration: 3000,
        },
      }}
    />
  );
}
